/* Radiance Veil — store refresh (see rv-refresh.css). */
(function () {
  /* 1. Scrollbar width for the full-width mega menu (rv-refresh.css §1). */
  function setScrollbarWidth() {
    var w = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--rv-sbw', (w > 0 ? w : 0) + 'px');
  }
  setScrollbarWidth();
  window.addEventListener('resize', setScrollbarWidth);

  /* 2. Quick add sizes: a color swatch click on a card points its size buttons at that color.
     The buttons themselves are the theme's quick-add triggers (product-item.liquid), which read
     data-product-id at click time. Delegated, so filtered / loaded-more cards work too. */
  function variantsFor(panel) {
    if (panel._rvVariants) return panel._rvVariants;
    var el = panel.querySelector('[data-rv-qa-variants]');
    try { panel._rvVariants = JSON.parse(el.textContent); } catch (e) { panel._rvVariants = []; }
    return panel._rvVariants;
  }
  function pointAtColor(panel, color) {
    if (panel.getAttribute('data-ci') === '-1') return;
    var variants = variantsFor(panel);
    panel.querySelectorAll('.rv-qa__size').forEach(function (btn) {
      var size = btn.getAttribute('data-size');
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i][1] === color && variants[i][2] === size) { match = variants[i]; break; }
      }
      if (match) btn.setAttribute('data-product-id', match[0]);
      btn.disabled = !(match && match[3]);
    });
  }
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest && e.target.closest('.product-item .product-swatches-options__item[data-option-value]');
    if (swatch) {
      var panel = swatch.closest('.product-item').querySelector('[data-rv-qa]');
      if (panel) pointAtColor(panel, swatch.getAttribute('data-option-value'));
      return;
    }
    var size = e.target.closest && e.target.closest('.rv-qa__size');
    if (size && !size.disabled) {
      size.classList.add('rv-qa__size--added');
      setTimeout(function () { size.classList.remove('rv-qa__size--added'); }, 1200);
    }
  }, true);
})();

// Product videos (snippets/media.liquid): always muted (no sound anywhere), tap/click the
// video to play or pause, pause when scrolled/swiped out of view, one video playing at a time.
(function () {
  function setup(box) {
    var v = box.querySelector('video'), btn = box.querySelector('[data-rv-video-btn]');
    if (!v || !btn) return;
    box.setAttribute('data-rv-video-ready', '');
    v.muted = true; v.defaultMuted = true; v.volume = 0; v.controls = false;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    v.addEventListener('volumechange', function () { if (!v.muted) v.muted = true; });
    var flashT;
    function sync() {
      box.classList.toggle('is-playing', !v.paused && !v.ended);
      btn.setAttribute('aria-label', v.paused ? 'Play video' : 'Pause video');
    }
    ['play', 'playing', 'pause', 'ended'].forEach(function (ev) { v.addEventListener(ev, sync); });
    box.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (v.paused || v.ended) {
        document.querySelectorAll('.rv-video video').forEach(function (o) { if (o !== v && !o.paused) o.pause(); });
        v.muted = true;
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else {
        v.pause();
      }
      box.classList.add('rv-video--flash'); clearTimeout(flashT);
      flashT = setTimeout(function () { box.classList.remove('rv-video--flash'); }, 700);
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (!en.isIntersecting && !v.paused) v.pause(); });
      }, { threshold: 0.25 }).observe(box);
    }
    sync();
  }
  function scan() { document.querySelectorAll('.rv-video:not([data-rv-video-ready])').forEach(setup); }
  scan();
  // variant changes / quick view re-render the gallery
  var queued = false;
  new MutationObserver(function () {
    if (queued) return; queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
